export default __webpack_public_path__ + "static/media/contratos.7e70c42c.png";